import { render, staticRenderFns } from "./RandoxKit.vue?vue&type=template&id=6ec555f7"
import script from "./RandoxKit.vue?vue&type=script&lang=js"
export * from "./RandoxKit.vue?vue&type=script&lang=js"
import style0 from "./RandoxKit.vue?vue&type=style&index=0&id=6ec555f7&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports